// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    api,
    IApiResponse,
    IPaginateApiResponse,
} from 'common/api/resources/Response';
import {
    IFailoverDomainPatchRequest,
    IFailoverDomainResponse,
} from 'common/api/resources/FailoverDomain/model';
import { IPaginatedWithSearch } from 'common/api/resources/Request/request';
import { QueryBuilder } from 'common/api/resources/Request/QueryBuilder';

export const failoverDomains = {
    list: (params?: IPaginatedWithSearch) => api.get<IPaginateApiResponse<IFailoverDomainResponse[]>>(
        'failover_domains',
        { params: new QueryBuilder(params).build() }
    ),
    // TODO SVM2-6923: add item(id) for edit form (GET /failover_domains/{id} exists on backend)
    patch: (id: number, data: IFailoverDomainPatchRequest) => api.patch<IApiResponse<IFailoverDomainResponse>>(
        `failover_domains/${id}`,
        data
    ),
    remove: (id: number) => api.delete(
        `failover_domains/${id}`
    ),
};
